// extracted by mini-css-extract-plugin
module.exports = {"trigger":"accordion_trigger__36fQm","icon":"accordion_icon__3kziA","rotate":"accordion_rotate__Ul3fH"};